import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { AbstractAccountActivityRespondentService } from '../abstraction/abstract.account-activity-respondent.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MockAccountActivityRespondentService extends AbstractAccountActivityRespondentService {
  private tableFilterJson = 'assets/mocks/fednow/accountactivity/respondent/tableFilter.json';
  private getCurrentNetActivityJson =
    'assets/mocks/fednow/accountactivity/respondent/getCurrentNetActivity.json';

  constructor(private http: HttpClient) {
    super();
  }

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.tableFilterJson));
  }

  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }

  tableExportExcel(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }

  getCurrentNetActivity(): Promise<string | undefined> {
    return lastValueFrom(this.http.get<string>(this.getCurrentNetActivityJson));
  }
}
